loadRelatedPostsSwiper = ->
  _require ['swiper'], ->
    new Swiper('.js-related-posts-swiper',
      spaceBetween: 30
      pagination: {
        el: '.js-swiper-related-posts-pagination'
      }
      clickable: true
      onInit: (swiper) ->
        if swiper.slides.length == 1
          $('.js-swiper-related-posts-pagination').hide()
    )

loadRelatedPostsSwiper()
